import { Offcanvas } from "bootstrap";
import closeAccordionMobile from "../commons/closeaccordionmobile";

const offcanvasPrestazione = () => {
    let offcanvasel = document.getElementById('offcanvasPrestazione');
    let offcanvasAll = document.querySelectorAll('.offcanvasMore');
    let psOffcanvas = new Offcanvas(offcanvasel);
    let offCanvasHandle = document.querySelectorAll('.openCanvasPrestazione');
    offCanvasHandle.forEach(function(handleitem) {
        handleitem.addEventListener('click', function(e) {
            e.preventDefault();
            let customtitle = document.getElementById('current_prestazione_title');
            
            if ( customtitle ) {
                customtitle.innerHTML = e.target.dataset.prestazionename;
            }
                      
            let prestazioneid = e.target.dataset.prestazioneid;
            let current_prestazione_id = document.getElementById('current_prestazione_id');
            if ( prestazioneid && current_prestazione_id ) current_prestazione_id.value = prestazioneid;

            let prestazionename = e.target.dataset.prestazionename;
            let current_prestazione_name = document.getElementById('current_prestazione_name');
            if ( prestazionename && current_prestazione_name) current_prestazione_name.value = prestazionename;

            offcanvasAll.forEach(function(canvas) {
                if(canvas.classList.contains('show')){
                    let allcanvas = Offcanvas.getInstance(canvas);
                    allcanvas.hide();
                }
                
            });  
            psOffcanvas.show();
         });
    });

}
export default offcanvasPrestazione;